import { overlayDisplayConfigSlice } from './reducer';
export const {
  appOverlayDisplayConfig,
  toolbarAndNavDisplayConfig
} = overlayDisplayConfigSlice.actions;